import React, { useState, useEffect } from "react";

export default function YearPicker() {
  // Detect the current query param for 'year' if it exists
  const [selectedYear, setSelectedYear] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    // Default to the current year (or pick whatever default you'd like)
    return urlParams.get("year") || new Date().getFullYear().toString();
  });

  const handleYearChange = (event) => {
    const newYear = event.target.value;
    setSelectedYear(newYear);

    // Create a new URL object from current window location
    const currentUrl = new URL(window.location.href);

    // Update or add 'year' query parameter
    currentUrl.searchParams.set("year", newYear);

    // Reload the page with the new query parameter
    window.location.href = currentUrl.toString();
  };

  // Build a list of years from 2022 up to the current year
  // (You can modify this range as desired)
  const years = [];
  for (let y = 2022; y <= new Date().getFullYear(); y++) {
    years.push(y);
  }

  return (
    <div className="objective-picker-container">
      <div className="objective-label">Year:</div>
      <div className="select-wrapper-objective">
        <select
          className="objective-picker dashboard-objective"
          name="dashboard_year"
          value={selectedYear}
          onChange={handleYearChange}
        >
          {years.map((yr) => (
            <option key={yr} value={yr}>
              {yr}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
